export const languages = [
  {
    id: "Punjabi",
    text: "ਧੰਨਵਾਦ",
    progress: 99,
  },
  {
    id: "Dogri",
    text: "धन्नवाद",
    progress: 99,
  },
  {
    id: "Hindi",
    text: "धन्यवाद",
    progress: 99,
  },
  {
    id: "English",
    text: "Thanks",
    progress: 90,
  },
  {
    id: "Urdu",
    text: "شکریہ",
    progress: 55,
  },
  {
    id: "Russian",
    text: "Спасибо",
    progress: 15,
  },
  {
    id: "Kazakh",
    text: "рахмет",
    progress: 8,
  },
]
